import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

export interface GettingProDialogProps {
    open: boolean;
}

const initialState: GettingProDialogProps = { open: false };

const gettingProDialogSlice = createSlice({
    name: 'gettingProDialog',
    initialState,
    reducers: {
        openGettingProDialog: (state) => {
            state.open = true;
            return state;
        },
        closeGettingProDialog: (state) => {
            state = initialState;
            return state;
        },
    },
});

export const { openGettingProDialog, closeGettingProDialog, } = gettingProDialogSlice.actions;
export default gettingProDialogSlice.reducer;
export const selectGettingProDialog = (state: RootState) => state.gettingProDialog;